import { useRef, type RefObject } from 'react';
import { useAppRouter, useRouteChangeStart } from '../useAppRouter';

/**
 * Returns a ref whose `.current` value is always the last route the user
 * navigated away from. Reading `.current` at call time (rather than at
 * render time) is intentional — it ensures long-lived callbacks always
 * see the latest value without needing a re-render.
 */
export const usePreviousRoute = (): RefObject<string | undefined> => {
  const router = useAppRouter();
  const previousPath = useRef<string | undefined>(undefined);
  const asPathRef = useRef(router.asPath);
  asPathRef.current = router.asPath;

  useRouteChangeStart(() => {
    previousPath.current = asPathRef.current;
  });

  return previousPath;
};
